<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageSeasonRateEditorRatePlans.title') }}
    </portal>
    <template v-if="ratePlans !== null">
      <card :title="$t('admin.pageSeasonRateEditorRatePlans.card.ratePlans')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <draggable v-model="ratePlans" group="ratePlans">
              <template v-for="ratePlan in ratePlans" v-if="ratePlan.type === 'DayRate' && !ratePlan.deleted">
                <div class="card__inner--line__wrapper">
                  <hm-card-inner-line :title="getName(ratePlan)" :clickable="true" :key="ratePlan.id" @click="routeToSeasonRateEditor(ratePlan)" />
                  <template v-for="ratePlan1 in ratePlan.childRatePlans" v-if="ratePlan1.type === 'DayRate' && !ratePlan1.deleted">
                    <hm-card-inner-line :title="`└ ${getName(ratePlan1)}`" :clickable="true" :key="ratePlan1.id" @click="routeToSeasonRateEditor(ratePlan1)" />
                    <template v-for="ratePlan2 in ratePlan1.childRatePlans" v-if="ratePlan2.type === 'DayRate' && !ratePlan2.deleted">
                      <hm-card-inner-line :title="`&nbsp;&nbsp;&nbsp;└ ${getName(ratePlan2)}`" :clickable="true" :key="ratePlan2.id" @click="routeToSeasonRateEditor(ratePlan2)" />
                      <template v-for="ratePlan3 in ratePlan2.childRatePlans" v-if="ratePlan3.type === 'DayRate' && !ratePlan3.deleted">
                        <hm-card-inner-line :title="`&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└ ${getName(ratePlan3)}`" :clickable="true" :key="ratePlan3.id" @click="routeToSeasonRateEditor(ratePlan3)" />
                      </template>
                    </template>
                  </template>
                </div>
              </template>
            </draggable>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="hasLicense('Packages')" :title="$t('admin.pageSeasonRateEditorRatePlans.card.packages')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <draggable v-model="ratePlans" group="packages">
              <template v-for="ratePlan in ratePlans" v-if="ratePlan.type === 'Package' && !ratePlan.deleted">
                <div class="card__inner--line__wrapper">
                  <hm-card-inner-line :title="getName(ratePlan)" :clickable="true" :key="ratePlan.id" @click="routeToSeasonRateEditor(ratePlan)" />
                  <template v-for="ratePlan1 in ratePlan.childRatePlans" v-if="ratePlan1.type === 'Package' && !ratePlan1.deleted">
                    <hm-card-inner-line :title="`└ ${getName(ratePlan1)}`" :clickable="true" :key="ratePlan1.id" @click="routeToSeasonRateEditor(ratePlan1)" />
                    <template v-for="ratePlan2 in ratePlan1.childRatePlans" v-if="ratePlan2.type === 'Package' && !ratePlan2.deleted">
                      <hm-card-inner-line :title="`&nbsp;&nbsp;&nbsp;└ ${getName(ratePlan2)}`" :clickable="true" :key="ratePlan2.id" @click="routeToSeasonRateEditor(ratePlan2)" />
                      <template v-for="ratePlan3 in ratePlan2.childRatePlans" v-if="ratePlan3.type === 'Package' && !ratePlan3.deleted">
                        <hm-card-inner-line :title="`&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└ ${getName(ratePlan3)}`" :clickable="true" :key="ratePlan3.id" @click="routeToSeasonRateEditor(ratePlan3)" />
                      </template>
                    </template>
                  </template>
                </div>
              </template>
            </draggable>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedRatePlans)" :title="$t('admin.pageSeasonRateEditorRatePlans.card.deletedRatePlans')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="ratePlan in deletedRatePlans"
                              :title="getName(ratePlan)"
                              :clickable="true"
                              :key="ratePlan.id"
                              @click="routeToSeasonRateEditor(ratePlan)" />
        </hm-card-inner>
      </card>
    </template>

  </main>
</template>

<script>
/* eslint func-names: 0 */

import PageRatePlans from './PageRatePlans';

export default {
  name: 'PageSeasonRateEditorRatePlans',

  extends: PageRatePlans,

  methods: {
    routeToSeasonRateEditor(ratePlan) {
      if (ratePlan != null && ratePlan.rateEntryMode === 'Daily') {
        this.$router.push({
          name: 'dailyRateEditor',
          params: {
            ratePlanId: ratePlan.id,
          },
        });
      } else if (ratePlan != null) {
        this.$router.push({
          name: 'seasonRateEditor',
          params: {
            ratePlanId: ratePlan.id,
          },
        });
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageSeasonRateEditorRatePlans.vue